import { useQuery } from 'hooks/useQuery'

import { fetchUsersByIds } from 'utils/queries'

import { UserType } from 'types/user'

export const useMultipleUsers = ({ userIds = [] }: { userIds: Array<string> }) => {
  const usersQuery = useQuery<Array<UserType | null>>(
    ['users', ...userIds],
    () => fetchUsersByIds(userIds),
    {
      enabled: userIds.length > 0,
    },
  )

  return usersQuery
}
